import { render, staticRenderFns } from "./NewSpeaker.vue?vue&type=template&id=b5e46e96&"
import script from "./NewSpeaker.vue?vue&type=script&lang=js&"
export * from "./NewSpeaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports